/**
 * @license
 * Copyright (c) 2017, Absa Group Limited, All Rights Reserved.
 */

// Angular
import {
  NgZone,
  ChangeDetectorRef,
  Component,
  ViewChild,
  AfterViewInit,
  ViewContainerRef,
  ElementRef,
  OnInit,
  Renderer2,
  TemplateRef,
  ViewEncapsulation,
} from "@angular/core";
import {
  Router,
  RouteConfigLoadStart,
  RouteConfigLoadEnd,
  NavigationStart,
  ActivatedRoute,
  NavigationEnd,
} from "@angular/router";
import { PopStateEvent, Location } from "@angular/common";

// RXJS
import { Subscription } from "rxjs/Subscription";
import { Observable } from "rxjs/Observable";
import { Subject } from "rxjs/Subject";

// Translate
import { TranslateService } from "@ngx-translate/core";

// @Celine API
import { ProgressIndicator } from "@api/models";
import { Experience } from "@threshold/models/experience";
import { Dashboard } from "@api/models/dashboard";
import {
  getDashboards,
  getProgressIndicator,
  getTheme,
} from "@api/store/app-store";

// NGRX
import { Store } from "@ngrx/store";

// Toastr
import { ToastsManager } from "ng2-toastr";

// ng-Bootstrap
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";

import { DashboardComponent } from "@api/components/dashboard/dashboard.component";
import { UserProfileSwitchRedirectComponent } from "@threshold/components/user/user-profile-switch-redirect.component";

// Services
import { NewRelicService } from "../services/new-relic.service";
import { FGWService } from "../services/fgw.service";
import {
  ConnectionService,
  ConnectionState,
} from "../services/connection-service.service";
import { UserProfileService } from "../services/user-profile.service";
import { UserPreferencesService } from "../services/user-preferences.service";
import { HistoryService } from "../services/history.service";

// LocalStorage
import { HelperStorage } from "./../storage-helper";

// Actions
import * as user from "../../celine/store/actions/user.actions";
import * as thresholdActions from "../store/actions/actions";
import * as ui from "@api/store/actions/ui.actions";

import {
  getBreadcrumb,
  getBannerClass,
  getBannerBackground,
  getShowMainMenu,
  getMainMenu,
  getShowBanner,
  getShowMenu,
  getContextNav,
  getShowContextNav,
  getBannerAlign,
  getShowProfileIcon,
  getBannerTitle,
  getBannerCaption,
  getApplicationTitle,
  getSize,
  getVariant,
  getColor,
  getDynamicMenu,
  getShowSearchControl,
  getShowSearchBar,
  getLocalizationDefaultLang,
  getShowDynamicSmallMenuWithNoChildren,
  getActivityFeature,
  getShowHeaderMasthead,
  getAllowExternalNavigation,
  getContainerClass,
  getExperience,
} from "../store/store";

import { getUser } from "@api/store/app-store";

import { SessionExpiredComponent } from "../components/session-expired/session-expired.component";
import { getLocalizationPackages } from "../store/reducers/reducer";
import { UserPreferences } from "@threshold/models/user-preferences";
import { ToasterService } from "@threshold/services/toast.service";
import "@celine/passive-tracking/dist";

declare var window: any;

const MINUTES_UNITL_AUTO_LOGOUT = 15; // in mins

const STORE_KEY = "lastAction";

const ACTIVITY_INTERVAL_TIME = 1500; // in ms DONT SET HIGH-TICK RATE
const JWT_INTERVAL_TIME = 1000;
const TIME_REMAINING_INTERVAL_TIME = 1000; // in ms DONT SET HIGH-TICK RATE
const TIME_REMAINING_TICK = 60;
const downloadAppModalSessionStorage = new HelperStorage(
  "sessionStorage",
  "",
  ""
);

/*
+++++++++++++++++++++++++++
| A p p C o m p o n e n t |
+++++++++++++++++++++++++++
*/

@Component({
  selector: "app-root",
  template: require('./app.component.html'),
  encapsulation: ViewEncapsulation.None,
  styles: [
    `
      solar-starlink-widget h2[heading] {
        font-weight: 400 !important;
      }
      .widget-mode solar-starlink-widget h2 {
        font-size: 20px !important;
        margin: 8px 0 !important;
      }
      .widget-mode solar-starlink-widget [description] p {
        font-size: 14px !important;
      }
      .widget-mode solar-starlink-widget [controls] a,
      .widget-mode solar-starlink-widget [controls] button {
        line-height: normal !important;
        font-size: 16px !important;
        font-family: "Source Sans Pro" !important;
      }
      .widget-mode solar-starlink-widget [controls] a:hover,
      .widget-mode solar-starlink-widget [controls] button:hover {
        text-decoration: none !important;
      }

      .widget-mode .threshold-container {
        padding: 0;
        min-height: 100vh;
      }
      .widget-mode .container-fluid {
        padding: 0;
        min-height: 100vh;
        background: #fff;
      }

      .absav2 solar-starlink-container > solar-starlink-widget {
        border-top: 7px solid #af144b !important;
      }
      .absav2 solar-starlink-container > solar-starlink-widget {
        border-top: 7px solid #af144b !important;
      }
      .absav2 solar-starlink-widget a,
      .absav2 solar-starlink-widget button,
      .absav2 solar-starlink-widget a::after,
      .absav2 solar-starlink-widget button::after {
        color: #f04e18 !important;
      }
      .absav2 .z3WUzho2U {
        fill: #af144b !important;
      }
      .absav2 .H9yWppve {
        fill: #f05a7d !important;
      }
      .absav2 .R2MFrqd3 {
        fill: #f05a7d !important;
      }
      .absav2 .mEoKNjVQ {
        fill: #870a3c !important;
      }

      /* solar-hero-virtualmeeting */
      .ohamuy {
        fill: #870a3c !important;
      }
      .afawab {
        fill: #af144b !important;
      }
      .atofat {
        fill: #6f0f48 !important;
      }
      .amuvip {
        fill: #f05a7d !important;
      }

      .udijit {
        fill: #af144b !important;
      }
      .udajaz {
        fill: #af144b !important;
      }
      .emoxuj {
        fill: #f05a7d !important;
      }

      .oropiv {
        fill: #af144b !important;
      }
      .okukiw,
      .ayahaz,
      .aqegek {
        fill: #870a3c !important;
      }
      .iqojes {
        fill: #6f0f48 !important;
      }
      .ujixor,
      .ogebon {
        fill: #6f0f48 !important;
      }

      .nbc solar-starlink-container > solar-starlink-widget {
        border-top: 7px solid #1f2860 !important;
      }
      .nbc solar-starlink-container > solar-starlink-widget {
        border-top: 7px solid #1f2860 !important;
      }
      .nbc solar-starlink-widget a,
      .nbc solar-starlink-widget button,
      .nbc solar-starlink-widget a::after,
      .nbc solar-starlink-widget button::after {
        color: #1f2860 !important;
      }
      .nbc .z3WUzho2U {
        fill: #1f2860 !important;
      }
      .nbc .R2MFrqd3 {
        fill: #224893 !important;
      }
      .nbc .mEoKNjVQ {
        fill: #1f2860 !important;
      }
      .nbc .H9yWppve {
        fill: #00395c !important;
      }

      solar-starlink-container > solar-starlink-widget {
        box-shadow: 0 1px 4px 0 rgba(12, 12, 13, 0.1) !important;
      }

      .wrapper {
        background: #f8f8f8;
        min-height: 100vh;
        position: relative;
      }
      .threshold-container-footer-padding {
        padding-bottom: 62px !important;
      }
      .download-mobile-app svg {
        position: absolute;
        top: -10px;
        left: 0;
        width: 398px;
      }
      .download-mobile-app .custom-body {
        margin-top: 200px;
      }
      .download-mobile-app .modal-body .custom-footer {
        margin: 35px -38px -38px;
        padding: 24px;
        border-top: 1px solid #f9f3f5;
      }
      .download-app-custom {
        border-left: none !important;
      }
      .download-app-custom div:focus {
        outline: none;
      }
      .download-app-custom span:first-child {
        font-size: 24px;
      }
      .download-app-custom span {
        color: #af144b !important;
        font-weight: 500 !important;
      }
      .custom-modal-styling .modal-content {
        padding: 40px 39px;
      }
    `,
  ],
})
export class AppComponent implements AfterViewInit, OnInit {
  @ViewChild("content") content: ElementRef;
  @ViewChild("logoutModal") logoutModal: ElementRef;
  @ViewChild("connectionStatusModal") connectionStatusModal: ElementRef;
  @ViewChild("notSignedInModal") notSignedInModal: ElementRef;
  @ViewChild("routerOutlet") routerOutlet: ElementRef;
  @ViewChild("downloadMobileAppModal") downloadMobileAppModal: ElementRef;

  dashboards$: Observable<Dashboard[]>;
  showContextNav$: Observable<boolean>;
  showProfileIcon$: Observable<boolean>;
  contextNav$: Observable<any>;
  bannerClass$: Observable<any>;
  bannerBackground$: Observable<any>;
  bannerAlign$: Observable<string>;
  bannerTitle$: Observable<string>;
  bannerCaption$: Observable<string>;
  applicationTitle$: Observable<string>;
  showMenu$: Observable<boolean>;
  showBanner$: Observable<boolean>;
  mainMenu$: Observable<any>;
  breadcrumb$: Observable<any>;
  showMainMenu$: Observable<boolean>;
  size$: Observable<string>;
  variant$: Observable<string>;
  color$: Observable<string>;
  progressIndicator: Observable<ProgressIndicator>;
  showSearchControl$: Observable<boolean>;
  showSearchBar$: Observable<boolean>;
  dynamicNav$: Observable<any>;
  showDynamicNav: boolean;
  showDynamicSmallMenuWithNoChildren$: Observable<boolean>;
  lang$: Observable<string>;
  langs$: Observable<any>;
  theme$: Observable<any>;
  activityFeature$: Observable<boolean>;
  showHeaderMasthead$: Observable<boolean>;
  allowExternalNavigation$: Observable<boolean>;
  experiences$: Observable<Experience[]>;
  containerClass$: Observable<any>;

  public documentTitle: string;
  public topNav: {
    title: string;
    alert: string;
    routerPath: string;
    children: any[];
  }[];
  public contextNav: { title: string; routerPath: string; children: any[] }[];

  // Intervals
  timeRemainingInterval: any;
  jwtInterval: any;
  activityInterval: any;
  isActivityEventAttach: boolean;

  // Activity event reference
  activityEventRef: any;

  // Max time remaining
  timeRemaining: Number = TIME_REMAINING_TICK;

  // Reference to ng-modal
  modalRef: NgbModalRef;
  mobileAppModalRef: NgbModalRef;

  // Show hide footer
  private showFooter: boolean;

  private loadingRouteConfig: boolean;
  public title: Subject<string>;

  // Do not show modal again checkbox
  public dontShowAgain: boolean = false;

  // Local storage current dont show modal again.
  private doNotShowDownloadMobileAppModal: boolean;
  private doNotShowDownloadMobileAppModalThisSession: boolean;

  public isRegisteredForMfa: boolean;
  private recommendMobileApplication: boolean;

  /**
   * Localization
   */
  private featTogLocalization = process.env.config.feature.localization.enabled;
  private languageChangeSubscription: Subscription = new Subscription();
  private translationsSubscriptions: Subscription = new Subscription();

  private favicon: any;

  /**
   * Web Workers
   */
  public workerActivity;
  public workerActivityPath = "web-worker-inactivity.js";
  public timer;

  public workerRemaining;
  public workerRemainingPath = "web-worker-remaining.js";

  private featsignOutUnloadEvent =
    process.env.config.feature.signOutUnloadEvent.enabled;
  private featNotifications = process.env.config.feature.notification.enabled;

  private widgetMode: boolean;
  private showHeader: boolean;
  private showNotSignedIn: boolean;

  public originalTheme: string;
  public allowRedirect: boolean;
  public allowBack: boolean;
  public isAbsaTheme: boolean;
  public showMobileAppModal: boolean;
  public showComplaintsLink: boolean;

  public connectionStatus: boolean = true;

  /**
   * AppComponent Constructor
   *
   * @param modalService
   * @param store
   * @param toastr
   * @param vcr
   */
  constructor(
    private connectionService: ConnectionService,
    private location: Location,
    private activatedRoute: ActivatedRoute,
    private fgw: FGWService,
    private ngZone: NgZone,
    private cd: ChangeDetectorRef,
    private translateService: TranslateService /* translation service */,
    private renderer: Renderer2 /* rendered to add/remove body class */,
    private router: Router /* router for url changes */,
    private modalService: NgbModal /* ng-bootstrap modal service */,
    private store: Store<any> /* ngrx store to dispatch actions */,
    private toastr: ToastsManager /* toastr */,
    private vcr: ViewContainerRef /* used by toastr */,
    private toasterService: ToasterService,
    private historyService: HistoryService,
    private nrService: NewRelicService /* new relic */,
    private userProfileService: UserProfileService,
    private userPreferencesService: UserPreferencesService
  ) {
    this.dashboards$ = this.store.select(getDashboards);
    this.showContextNav$ = this.store.select(getShowContextNav);
    this.contextNav$ = this.store.select(getContextNav);
    this.bannerAlign$ = this.store.select(getBannerAlign);
    this.showProfileIcon$ = this.store.select(getShowProfileIcon);
    this.bannerTitle$ = this.store.select(getBannerTitle);
    this.bannerCaption$ = this.store.select(getBannerCaption);
    this.applicationTitle$ = this.store.select(getApplicationTitle);
    this.showMenu$ = this.store.select(getShowMenu);
    this.showBanner$ = this.store.select(getShowBanner);
    this.mainMenu$ = this.store.select(getMainMenu);
    this.breadcrumb$ = this.store.select(getBreadcrumb);
    this.showMainMenu$ = this.store.select(getShowMainMenu);
    this.bannerClass$ = this.store.select(getBannerClass);
    this.bannerBackground$ = this.store.select(getBannerBackground);
    this.size$ = this.store.select(getSize);
    this.color$ = this.store.select(getColor);
    this.variant$ = this.store.select(getVariant);
    this.showSearchControl$ = this.store.select(getShowSearchControl);
    this.showSearchBar$ = this.store.select(getShowSearchBar);
    this.dynamicNav$ = this.store.select(getDynamicMenu);
    this.showDynamicSmallMenuWithNoChildren$ = this.store.select(
      getShowDynamicSmallMenuWithNoChildren
    );
    this.lang$ = this.store.select(getLocalizationDefaultLang);
    this.langs$ = this.store.select(getLocalizationPackages);
    this.theme$ = this.store.select(getTheme);
    this.activityFeature$ = this.store.select(getActivityFeature);
    this.showHeaderMasthead$ = this.store.select(getShowHeaderMasthead);
    this.allowExternalNavigation$ = this.store.select(
      getAllowExternalNavigation
    );
    this.containerClass$ = this.store.select(getContainerClass);
    this.experiences$ = this.store.select(getExperience);
    this.showMobileAppModal = JSON.parse(window["__CONFIGURATION"])[
      "supportMobileMfa"
    ]
      ? JSON.parse(window["__CONFIGURATION"])["supportMobileMfa"]
      : false;
    this.showComplaintsLink = JSON.parse(window["__CONFIGURATION"])[
      "showComplaintsLink"
    ]
      ? JSON.parse(window["__CONFIGURATION"])["showComplaintsLink"]
      : false;

    setTimeout(() => {
      this.progressIndicator = store.select(getProgressIndicator);
    });

    // Create reference to event, so that we can later deattach event
    this.activityEventRef = (event) => this.activityReset(event);

    // Onload: Lets add activity events
    this.isActivityEventAttach = true;
    this.activityAddListener();

    // Set current time
    localStorage.setItem(STORE_KEY, Date.now().toString());

    // Set root view for toastr
    this.toastr.setRootViewContainerRef(this.vcr);

    // Fix for IE10
    this.dynamicNav$.subscribe((menu: Array<any>) => {
      if (menu.length > 0) this.showDynamicNav = true;
      else this.showDynamicNav = false;
    });

    this.favicon = document.getElementById("favicon") as any;

    this.applicationTitle$.subscribe((title) => {
      this.documentTitle = title;
    });

    this.theme$.subscribe((theme) => {
      this.renderer.removeClass(document.body, "absa");
      this.renderer.removeClass(document.body, "absav2");
      this.renderer.removeClass(document.body, "barclays");
      this.renderer.removeClass(document.body, "nbc");

      if (this.fgw.getTheme().indexOf("absa") !== -1) {
        this.renderer.addClass(document.body, "absav2");
      } else {
        this.renderer.addClass(document.body, "nbc");
      }
    });

    // Setup inactivity functionality
    this.activityFeature$.subscribe((flag) => {
      if (flag) this.activityWebWorker();
      else this.terminateWebWorkers();
    });

    // Popstate event
    this.location.subscribe((popStateEvent: PopStateEvent) => {
      if (popStateEvent.type === "popstate") {
        if (!this.allowBack && !this.widgetMode) {
          ineum("reportEvent", "@celine: User signed out by clicking back");
          this.initLogout();
        }
      }
    });

    this.activatedRoute.queryParams.subscribe((params) => {
      this.widgetMode = params["widgetMode"];

      if (this.widgetMode) {
        this.renderer.addClass(document.body, "widget-mode");
        this.allowRedirect = true; // frame allows
        this.allowBack = true;
        // this.store.dispatch(new thresholdActions.SetAllowExternalNavigationAction(true));
        // this.store.dispatch(new thresholdActions.SetUserActivityAction(false));
        this.connectionService.destory();
      }

      this.showHeader = !this.widgetMode;
    });

    this.allowExternalNavigation$.subscribe((allowRedirect) => {
      this.allowRedirect = allowRedirect;
      if (allowRedirect) {
        localStorage.removeItem("celineResetV1");
        localStorage.removeItem("celineResetV2");
      }
    });

    // assign loaded theme
    this.originalTheme = this.fgw.getTheme();

    this.showNotSignedIn = true;

    this.initConnectionStatus();
    this.initUserSignedOut();
  }

  /**
   *
   */
  initConnectionStatus() {
    let modalRef: NgbModalRef;
    this.connectionService.updateOptions({ enableHeartbeat: true });
    this.connectionService
      .monitor()
      .subscribe((currentState: ConnectionState) => {
        if (
          !currentState.hasNetworkConnection &&
          !currentState.hasInternetAccess
        ) {
          if (modalRef) {
            modalRef.dismiss(() => {});
          }
          modalRef = this.modalService.open(this.connectionStatusModal, {
            keyboard: false,
            backdrop: "static",
          });
          this.connectionStatus = false;
        } else {
          this.connectionStatus = true;
          this.ngZone.runOutsideAngular(() => {
            if (modalRef) {
              setTimeout(() => {
                modalRef.close();
              }, 2000);
            }
          });
        }
      });
  }

  /**
   *
   */
  initUserSignedOut(): void {
    window.addEventListener(
      "message",
      (event: any) => {
        if (
          event.origin !==
          location.protocol +
            "//" +
            location.hostname +
            (location.port ? ":" + location.port : "")
        )
          return;

        if (event.data === "__CELINE_signout") {
          this.modalService.open(this.notSignedInModal, {
            keyboard: false,
            backdrop: "static",
          });
        }
      },
      false
    );
  }

  /**
   *
   */
  ngOnInit() {
    window.addEventListener("RUMSCRIPT.READY", (event) => {
      aat("passive");
      // aat("config", { key: "celine", angularVersion: "4.4.6" });
      aat("observeElements");
      this.store.select(getUser).subscribe((user) => {
        aat("userProfileId", user.id);
      });
    });

    this.ngZone.runOutsideAngular(() => {
      var monitor = setInterval(function () {
        var elem = document.activeElement;
        if (elem && elem.tagName == "IFRAME") {
          localStorage.removeItem("celineResetV2");
          localStorage.removeItem("celineResetV3");
          clearInterval(monitor);
        }
      }, 100);
    });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        aat("unobserveUpdates");
        if (window["celineTargetCE"])
          this.renderer.removeClass(document.body, window["celineTargetCE"]);

        // always attempt to re-add events
        this.store.dispatch(new thresholdActions.SetUserActivityAction(true));

        // close warning window, if instance
        if (this.modalRef) {
          this.modalRef.close();
        }

        try {
          let currentApplication;
          let url = event.url.substring(1, event.url.length);

          // http://domain/#/experience
          if (url.lastIndexOf("/") === -1) {
            currentApplication = url.substring(0, url.length);
          }
          // http://domain/#/experience/page2
          else if (url.lastIndexOf("/") > 0) {
            currentApplication = url.substring(0, url.indexOf("/"));
          }
          window["celineTargetCE"] = currentApplication.replace("?=", "");
          if (window["celineTargetCE"])
            this.renderer.addClass(document.body, window["celineTargetCE"]);
        } catch (error) {
          console.error(error);
        }
      }

      if (event instanceof NavigationEnd) {
        this.allowRedirect = false;

        // On the dashboard
        if (!this.widgetMode && event.url === "/") {
          this.allowBack = true;
        } else {
          this.allowBack = false;
        }

        // send page url
        // if (process.env.config.isProduction) {
        let url = event.url.substring(1, event.url.length);
        if (url != "" && url.indexOf("widget-frame") === -1) {
          if (
            event.url.indexOf("?") === -1 &&
            event.url.indexOf("=") === -1 &&
            event.url !== "/" &&
            event.url !== "/id_token"
          ) {
            this.historyService.sendHistory(url);
            if (event.id > 1)
              setTimeout(() => {
                if (
                  window["celineTargetCE"] &&
                  this.fgw.getTag(window["celineTargetCE"], "aat") &&
                  this.fgw.getTag(window["celineTargetCE"], "aat") === "true"
                ) {
                  window.addEventListener("RUMSCRIPT.READY", () =>
                    aat("observeUpdates", window["celineTargetCE"])
                  );
                  aat("observeUpdates", window["celineTargetCE"]);
                }
                // aat("recordPageView", `/${url}`);
              });
          }
        }
        // }

        // log page
        if (
          event.url.indexOf("?") === -1 &&
          event.url.indexOf("=") === -1 &&
          event.url !== "/" &&
          event.url !== "/id_token"
        ) {
          ineum("page", event.url);

          // fraud fabric tracker
          if (typeof fft !== "undefined") fft && fft("page", event.url);
        }

        // if (event.id > 1 && event.url == "/")
        //   setTimeout(() => {
        //     aat("recordPageView", "home-page");
        //   });
      }

      if (event instanceof RouteConfigLoadStart) {
        this.loadingRouteConfig = true;
      } else if (event instanceof RouteConfigLoadEnd) {
        this.loadingRouteConfig = false;
      }
    });
    this.isAbsaTheme =
      this.fgw.getTheme().toLowerCase() === "absa" ||
      this.fgw.getTheme().toLowerCase() === "absav2"
        ? true
        : false;
  }

  /**
   * Respond after Angular initializes the component's views and child views / the view that a directive is in
   */
  ngAfterViewInit() {
    document.getElementById("skeleton").classList.add("zeroOpacity");
  }

  /**
   */
  beforeUnloadEventListener(e) {}

  /**
   * Terminate Web Workers
   */
  terminateWebWorkers() {
    if (this.workerActivity) {
      this.workerActivity.terminate();
      this.workerActivity = null;
    }

    if (this.workerRemaining) {
      this.workerRemaining.terminate();
      this.workerRemaining = null;
    }
  }

  onlineCheck() {
    let xhr = new XMLHttpRequest();
    return new Promise((resolve, reject) => {
      xhr.onload = () => {
        // Set online status
        resolve(true);
      };
      xhr.onerror = () => {
        // Set online status
        reject(false);
      };
      xhr.open("GET", JSON.parse(window["__CONFIGURATION"])["authUrl"], true);
      xhr.send();
    });
  }

  /**
   *
   */
  remainingWebWorker() {
    let globalThis = this;

    if (typeof Worker !== "undefined") {
      // Check whether Web Worker has been created.
      if (this.workerRemaining == null) {
        // create instance of web worker
        if (navigator.onLine) {
          this.workerRemaining = new Worker(this.workerRemainingPath);

          // let globalThis = this;
          let originalDocumentTitle = document.title;
          let newDocumenTitle = "Session warning";

          /**
           * Web Worker Events
           */
          this.workerRemaining.onmessage = function (workerEvent) {
            globalThis.ngZone.run(() => {
              if (workerEvent.data.complete) {
                // terminate all web workers
                globalThis.terminateWebWorkers();
              }

              if (workerEvent.data.remaining !== undefined) {
                // Flash document title
                if (document.title === originalDocumentTitle) {
                  document.title = newDocumenTitle;
                  globalThis.favicon.href = `assets/favicon/${globalThis.fgw.getTheme()}-alert.ico`;
                } else {
                  document.title = originalDocumentTitle;
                  globalThis.favicon.href = `assets/favicon/${globalThis.fgw.getTheme()}.ico`;
                }

                // Update favicon
                // globalThis.favicon.href = `assets/favicon/${globalThis.fgw.getTheme()}-alert.ico`;

                // Get seconds remaining
                globalThis.timeRemaining = workerEvent.data.remaining;

                // Almost done, we go
                if (globalThis.timeRemaining === 0) {
                  ineum(
                    "reportEvent",
                    "@celine: Auto sign out due to inactivity"
                  );
                  globalThis.favicon.href = `assets/favicon/${globalThis.fgw.getTheme()}.ico`;
                  document.title = `${originalDocumentTitle}`;
                  globalThis.initLogout();
                }
              }
            });
          };
        } else {
          // Has no internet connection, let the user know
          window.location =
            location.protocol +
            "//" +
            location.hostname +
            (location.port ? ":" + location.port : "") +
            `/#/session-expired`;
        }
      }
    } else {
      // Web workers are not supported by your browser
      this.timer = "Sorry, your browser does not support Web Workers ...";
    }
  }

  /**
   *
   */
  activityWebWorker() {
    // Reset time remaining
    if (this.workerRemaining) {
      this.timeRemaining = 60;
      this.workerRemaining.terminate();
      this.workerRemaining = null;
    }

    // This make the executed code don't fire angular detection changes
    this.ngZone.runOutsideAngular(() => {
      // check whether web workers are supported
      if (typeof Worker !== "undefined") {
        // Check whether Web Worker has been created. If not, create a new Web Worker based on the Javascript file simple-timer.js
        if (this.workerActivity == null) {
          // create instance of web worker
          this.workerActivity = new Worker(this.workerActivityPath);
        }

        // reference to this
        let globalThis = this;

        /**
         * Web Worker Events
         */
        this.workerActivity.onmessage = function (workerEvent) {
          // reference
          let webWorkerThis = this;

          if (workerEvent.data.complete) {
            // Terminate Activity Web Worker
            webWorkerThis.terminate();
            globalThis.workerActivity = null;

            // Start second remaining web worker
            globalThis.remainingWebWorker();

            // Run back into Angular
            globalThis.ngZone.run(() => {
              ineum(
                "reportEvent",
                "@celine: Session warning due to inactivity"
              );
              globalThis.open(globalThis.content);
            });
          }
        };
      } else {
        // Web workers are not supported by your browser
        this.timer = "Sorry, your browser does not support Web Workers ...";
      }
    });
  }

  /**
   *
   */
  switchLang(lang: string) {
    this.store.dispatch(
      new thresholdActions.SetLocalizationDefaultLangAction(lang)
    );
  }

  /**
   * Compares JWT expire datetime and with current datetime.
   * If token expire, automatically logouts user
   */
  private jwtTimeout() {
    if (sessionStorage.getItem("authorizationDataIdToken") != null) {
      let authData = this.parseJwt(
        sessionStorage.getItem("authorizationDataIdToken")
      );
      let currentDateTime = new Date();
      // currentDateTime.setMinutes(currentDateTime.getMinutes() + 55);
      let currentTime = currentDateTime.getTime() / 1000;
      if (currentTime > parseInt(authData["exp"])) {
        clearInterval(this.jwtInterval);
        this.router.navigate(["/session-expired"]);
      }
    }
  }

  // Get last action
  public getLastAction() {
    return parseInt(localStorage.getItem(STORE_KEY));
  }

  // Set Last action
  private setLastAction(lastAction: number) {
    localStorage.setItem(STORE_KEY, lastAction.toString());
  }

  // Start Interval Functions -->
  private startJwtInterval() {
    this.jwtInterval = setInterval(() => {
      this.jwtTimeout();
    }, JWT_INTERVAL_TIME);
  }

  private startActivityInterval() {
    this.activityInterval = setInterval(() => {
      this.activityTimeout();
    }, ACTIVITY_INTERVAL_TIME);
  }

  private startActivityRemainingInterval() {
    this.timeRemainingInterval = setInterval(() => {
      this.timeRemainingTimeout();
    }, TIME_REMAINING_INTERVAL_TIME);
  }

  // Stop / Clear Interval Functions -->
  private stopJwtInterval() {
    clearInterval(this.jwtInterval);
  }

  private stopActivityInterval() {
    clearInterval(this.activityInterval);
  }

  private stopTimeRemainingInterval() {
    clearInterval(this.timeRemainingInterval);
    this.timeRemaining = TIME_REMAINING_TICK;
  }

  /**
   *
   * @param event
   */
  public onRouterOutletActivate(event: any) {
    // if silent-refresh in the background...
    // run check the token again
    // this.jwtTimeout();

    this.renderer.removeClass(document.body, "threshold-dashboard");

    window.scroll(0, 0);

    if (event instanceof UserProfileSwitchRedirectComponent) {
      this.showNotSignedIn = false;
    } else {
      this.showNotSignedIn = true;
    }

    if (event instanceof DashboardComponent) {
      this.showFooter = true;
      this.store.dispatch({
        type: "[UI] Goto theme",
        payload: this.originalTheme,
      });
      this.store.dispatch(
        new thresholdActions.SetContainerClassAction("threshold-container")
      );

      // sticky bug fix
      try {
        if (document.getElementsByClassName("header-sticky")[0]) {
          this.renderer.removeClass(
            document.getElementsByClassName("header-sticky")[0],
            "header-sticky"
          );
        }
      } catch (error) {
        console.warn("header sticky");
      }

      this.store.dispatch(new thresholdActions.ShowBannerAction());
      this.store.dispatch(
        new thresholdActions.SetVariantAction("jumbo-variant-dark")
      );
      this.store.dispatch(new thresholdActions.SetBannerBackgroundAction(""));
      this.store.dispatch(new thresholdActions.SetSizeAction("sol-jumbo-h1"));
      this.store.dispatch(new thresholdActions.HideContextNavAction());
      this.store.dispatch(new thresholdActions.HideMenuAction());
      this.store.dispatch(new thresholdActions.HideMainMenuAction());
      this.store.dispatch(new thresholdActions.HideProfileBannerAction());
      this.store.dispatch(new thresholdActions.SetDynamicMenuAction([]));
      this.store.dispatch(new thresholdActions.SetBreadcrumbAction([]));
      this.store.dispatch(
        new thresholdActions.SetBannerClassAction("sol-header")
      );
      this.store.dispatch(new thresholdActions.SetUserActivityAction(true));
      this.store.dispatch(new thresholdActions.ShowHeaderMastheadAction());
      this.store.dispatch(new thresholdActions.SetBannerTitleAction(""));
      this.store.dispatch(new thresholdActions.SetApplicationTitleAction(""));
      this.store.dispatch(new thresholdActions.HideBannerAction());
      this.renderer.addClass(document.body, "threshold-dashboard");

      if (this.fgw.getTheme().indexOf("absa") !== -1) {
        document.title = "Absa Access";
      } else {
        document.title = "NBC Access";
      }

      // Display "Download the app" modal on dashboard if Absa theme.
      if (this.isAbsaTheme && this.showMobileAppModal) {
        this.mobileAppModal();
      }
    } else {
      this.showFooter = false;

      // clear subscriptions
      this.translationsSubscriptions.unsubscribe();
      this.languageChangeSubscription.unsubscribe();
    }

    if (event instanceof SessionExpiredComponent) {
      // stop all timers
      this.stopActivityInterval();
      this.stopJwtInterval();
      this.stopTimeRemainingInterval();
      this.terminateWebWorkers();
    }
  }

  /**
   * Perform logout procedure...
   * hiding screens
   * showing screens
   * stopping timers
   */
  initLogout() {
    localStorage.removeItem("celineResetV1");
    localStorage.removeItem("celineResetV2");

    // this.store.dispatch(new thresholdActions.SetAllowExternalNavigationAction(true));
    this.store.dispatch(new ui.ShowProgressIndicatorAction({ status: true }));

    ineum("reportEvent", "@celine: User signed out");

    // close warning window, if instance
    if (this.modalRef) this.modalRef.close();

    // stop all timers
    this.stopActivityInterval();
    this.stopJwtInterval();
    this.stopTimeRemainingInterval();

    // show logout modal
    //this.modalService.open(this.logoutModal, { keyboard: false, backdrop: 'static' });

    // fire action
    this.store.dispatch(new user.LogoffAction());
  }

  /**
   *
   */
  private getComponentTranslations() {
    this.store.dispatch(new thresholdActions.SetBannerTitleAction(""));
    this.store.dispatch(new thresholdActions.HideBannerAction());
  }

  /**
   * Add page listeners.  click, mouse, keys events...
   * This listens for activity on the page
   */
  private activityAddListener() {
    document.body.addEventListener("click", this.activityEventRef);
    document.body.addEventListener("keydown", this.activityEventRef);
    document.body.addEventListener("keyup", this.activityEventRef);
    document.body.addEventListener("keypress", this.activityEventRef);
  }

  /**
   * Remove page listeners
   */
  private activityRemoveListener() {
    document.body.removeEventListener("click", this.activityEventRef);
    document.body.removeEventListener("keydown", this.activityEventRef);
    document.body.removeEventListener("keyup", this.activityEventRef);
    document.body.removeEventListener("keypress", this.activityEventRef);
  }

  /**
   * Reset page activity. e.g. User did something
   */
  private activityReset(event?) {
    // Post latest timestamp to activity web-worker
    if (this.workerActivity) {
      this.workerActivity.postMessage({ lastActionTime: Date.now() });
    }

    this.setLastAction(Date.now());
  }

  /**
   * Count down, on Zero, we logout
   */
  private timeRemainingTimeout() {
    this.timeRemaining = <number>this.timeRemaining - 1;
    if (this.timeRemaining === 0) {
      this.initLogout();
    }
  }

  /**
   * Activity timeout, checking time-passed with last activity
   */
  private activityTimeout() {
    const now = Date.now();
    const timeleft =
      this.getLastAction() + MINUTES_UNITL_AUTO_LOGOUT * 60 * 1000;
    const diff = timeleft - now;
    const isTimeout = diff < 0;

    if (isTimeout) {
      this.activityRemoveListener();
      this.stopActivityInterval();
      // this.startActivityRemainingInterval();
      this.open(this.content);
    }
  }

  private open(content) {
    this.modalRef = this.modalService.open(content, {
      keyboard: false,
      backdrop: "static",
    });

    this.modalRef.result.then(
      (result) => {
        switch (result) {
          case "continue": {
            // Reset original title
            document.title = this.documentTitle;

            // Reset favicon
            this.favicon.href = `assets/favicon/${this.fgw.getTheme()}.ico`;

            // this.activityAddListener();
            // this.startActivityInterval();
            // this.stopTimeRemainingInterval();

            this.activityWebWorker();

            break;
          }
          case "logout": {
            this.initLogout();
            break;
          }
        }
      },
      (reason) => {}
    );
  }

  /**
   * Checks if feature is feature toggled or "do not show" has been stored locally and if not displays modal
   */
  private mobileAppModal() {
    // if (this.userProfileService.getFeatureFlagsFromLocalStorage() !== null && !this.userProfileService.haveFlagsExpired(59)) {
    // 	this.renderMobileAppView();
    // } else {
    // 	this.userProfileService.setFeatureFlagsConfig().subscribe(() => {
    // 		this.renderMobileAppView();
    // 	})
    // }
  }

  private renderMobileAppView() {
    this.userProfileService
      .getFeatureFlagMatch(["DownloadMobileAppModal"])
      .subscribe((noFeatureFlagMatchFound) => {
        // Only show modal and do user preferences call once per session
        this.doNotShowDownloadMobileAppModalThisSession = JSON.parse(
          sessionStorage.getItem("doNotShowMobileModalThisSession")
        );

        if (!this.doNotShowDownloadMobileAppModalThisSession) {
          this.userPreferencesService.getUserPreferences().subscribe(
            (response: UserPreferences) => {
              // Has user registered a MFA device? If registered hide "download the app" button in banner
              this.isRegisteredForMfa = response.isRegisteredForMfa;

              // Has "Do not show again" been checked?
              this.recommendMobileApplication =
                response.recommendMobileApplication;

              if (this.recommendMobileApplication && noFeatureFlagMatchFound) {
                this.mobileAppModalRef = this.modalService.open(
                  this.downloadMobileAppModal,
                  {
                    keyboard: false,
                    backdrop: "static",
                    size: "sm",
                    windowClass: "custom-modal-styling",
                  }
                );
              }
            },
            () => {
              this.toasterService.error(
                "Error",
                "Unable to get user preferences, please try again later."
              );
            }
          );
        }
      });
  }

  /**
   * JWT parser
   * @param token
   */
  parseJwt(token) {
    let base64Url = token.split(".")[1];
    let base64 = base64Url.replace("-", "+").replace("_", "/");
    return JSON.parse(window.atob(base64));
  }

  /** Set the title */
  public onTitleSet(subject: Subject<string>) {
    this.title = subject;
  }

  public signIn() {
    window.location.href = "/";
  }

  /**
   * Sets local storage and closes modal
   */
  public doNotShow(doNotShowModal: boolean) {
    // Has "Do not show again" been checked? if it has do put api call to set user preference
    if (doNotShowModal) {
      this.userPreferencesService.updateUserPreferencesHideModal().subscribe(
        () => {},
        () => {
          this.toasterService.error(
            "Error",
            "Unable to update preference, please try again later."
          );
        }
      );
    }

    // Only show modal once per session
    downloadAppModalSessionStorage.set("doNotShowMobileModalThisSession", true);
    if (this.mobileAppModalRef) this.mobileAppModalRef.close();
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/components/app.component.ts